import { useEffect, useRef } from "react";

export default function useManagementDialog(onClose, busy, allowsFocus, enabled = true) {
  const ref = useRef(null);
  const state = useRef({ onClose, busy, allowsFocus });
  state.current = { onClose, busy, allowsFocus };
  useEffect(() => {
    if (!enabled || !ref.current) return undefined;
    const previous = document.activeElement;
    const dialog = ref.current;
    const focusable = () => [...dialog.querySelectorAll('button:not(:disabled), input:not(:disabled), select:not(:disabled), textarea:not(:disabled), [href], [tabindex="0"]')];
    const first = () => (focusable()[0] || dialog).focus();
    first();
    const trapFocus = (event) => {
      if (!dialog.contains(event.target) && !state.current.allowsFocus?.(event.target)) first();
    };
    const keyDown = (event) => {
      if (state.current.allowsFocus?.(event.target)) return;
      if (event.key === "Escape" && !state.current.busy) { event.preventDefault(); state.current.onClose(); }
      if (event.key !== "Tab") return;
      const elements = focusable();
      const start = elements[0] || dialog, end = elements[elements.length - 1] || dialog;
      if (event.shiftKey && document.activeElement === start) { event.preventDefault(); end.focus(); }
      else if (!event.shiftKey && document.activeElement === end) { event.preventDefault(); start.focus(); }
    };
    document.addEventListener("focusin", trapFocus);
    document.addEventListener("keydown", keyDown);
    return () => {
      document.removeEventListener("focusin", trapFocus);
      document.removeEventListener("keydown", keyDown);
      if (previous?.isConnected) previous.focus();
    };
  }, [enabled]);
  return ref;
}
